import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export const SuccessPanel = ({ title, text, reference, actions = [], testid = "success-panel" }) => (
  <div className="card-base mx-auto max-w-xl p-10 text-center" data-testid={testid}>
    <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-600" />
    <h2 className="mt-5 text-2xl font-bold text-slate-900">{title}</h2>
    <p className="mt-3 text-slate-600">{text}</p>
    {reference && (
      <p className="mt-5 inline-block rounded-md bg-slate-100 px-4 py-2 text-sm">
        Reference <span className="mono font-semibold text-slate-900" data-testid={`${testid}-reference`}>{reference}</span>
      </p>
    )}
    <div className="mt-8 flex flex-wrap justify-center gap-3">
      {actions.map((a, i) => (
        <Link key={a.to} to={a.to} className={i === 0 ? "btn-dark" : "btn-outline"} data-testid={`${testid}-action-${i}`}>
          {a.label}
        </Link>
      ))}
    </div>
  </div>
);
